function Separador() {
    return (<div className="separador"></div>);
}
export default Separador;